import React, { useState, useEffect, useContext } from 'react';
import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const BibleSearch = ({ onSearch, resetTrigger }) => {
    const { auth } = useContext(AuthContext);
    const [books, setBooks] = useState([]);
    const [selectedBook, setSelectedBook] = useState('');
    const [chapters, setChapters] = useState([]);
    const [selectedChapter, setSelectedChapter] = useState('');
    const [verses, setVerses] = useState([]);
    const [selectedVerse, setSelectedVerse] = useState('');

    useEffect(() => {
        const fetchBooks = async () => {
            try {
                const res = await axios.get('/api/bible/books', {
                    headers: {
                        'x-auth-token': auth.token
                    }
                });
                setBooks(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchBooks();
    }, [auth.token]);

    useEffect(() => {
        if (selectedBook) {
            const fetchChapters = async () => {
                try {
                    const res = await axios.get(`/api/bible/books/${selectedBook}/chapters`, {
                        headers: {
                            'x-auth-token': auth.token
                        }
                    });
                    setChapters(res.data);
                    setSelectedChapter('');
                    setVerses([]);
                    setSelectedVerse('');
                } catch (err) {
                    console.error(err);
                }
            };
            fetchChapters();
        } else {
            setChapters([]);
            setVerses([]);
        }
    }, [selectedBook, auth.token]);

    useEffect(() => {
        if (selectedBook && selectedChapter) {
            const fetchVerses = async () => {
                try {
                    const res = await axios.get(`/api/bible/books/${selectedBook}/${selectedChapter}/verses`, {
                        headers: {
                            'x-auth-token': auth.token
                        }
                    });
                    setVerses(res.data);
                    setSelectedVerse('');
                } catch (err) {
                    console.error(err);
                }
            };
            fetchVerses();
        } else {
            setVerses([]);
        }
    }, [selectedBook, selectedChapter, auth.token]);

    useEffect(() => {
        onSearch({
            book: selectedBook,
            chapter: selectedChapter,
            verse: selectedVerse
        });
    }, [selectedBook, selectedChapter, selectedVerse]);

    useEffect(() => {
        if (resetTrigger) {
            setSelectedBook('');
            setSelectedChapter('');
            setSelectedVerse('');
        }
    }, [resetTrigger]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={7}>
                <FormControl fullWidth variant="outlined" sx={{ minWidth: 240 }}>
                    <InputLabel>Книга</InputLabel>
                    <Select value={selectedBook} onChange={(e) => setSelectedBook(e.target.value)} label="Книга">
                        <MenuItem value=""><em>None</em></MenuItem>
                        {books.map((book) => (
                            <MenuItem key={book.book_number} value={book.book_number}>
                                {book.long_name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={2}>
                <FormControl fullWidth variant="outlined" sx={{ minWidth: 90 }} disabled={!selectedBook}>
                    <InputLabel>Глава</InputLabel>
                    <Select value={selectedChapter} onChange={(e) => setSelectedChapter(e.target.value)} label="Глава">
                        <MenuItem value=""><em>None</em></MenuItem>
                        {chapters.map((chapter) => (
                            <MenuItem key={chapter} value={chapter}>
                                {chapter}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
                <FormControl fullWidth variant="outlined" sx={{ minWidth: 120 }} disabled={!selectedChapter}>
                    <InputLabel>Стих</InputLabel>
                    <Select 
                        value={selectedVerse} 
                        onChange={(e) => setSelectedVerse(e.target.value)} 
                        label="Стих"
                        renderValue={(selected) => {
                            if (!selected) {
                                return <em>None</em>;
                            }
                            return selected;
                        }}
                    >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {verses.map((verse) => (
                            <MenuItem key={verse.verse} value={verse.verse}>
                                {verse.verse} - {verse.text.substring(0, 50)}...
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};

export default BibleSearch;
